/* WORKFLOW CONFIG */
export const FETCH_WORKFLOW_CONFIG = "FETCH_WORKFLOW_CONFIG"
export const FETCH_WORKFLOW_CONFIG_SUCCESS = "FETCH_WORKFLOW_CONFIG_SUCCESS"
export const FETCH_WORKFLOW_CONFIG_FAIL = "FETCH_WORKFLOW_CONFIG_FAIL"

export const SAVE_WORKFLOW_CONFIG = "SAVE_WORKFLOW_CONFIG"
export const SAVE_WORKFLOW_CONFIG_SUCCESS = "SAVE_WORKFLOW_CONFIG_SUCCESS"
export const SAVE_WORKFLOW_CONFIG_FAIL = "SAVE_WORKFLOW_CONFIG_FAIL"

/* ORDER TRANSITIONS */
export const FETCH_ORDER_TRANSITIONS = "FETCH_ORDER_TRANSITIONS"
export const FETCH_ORDER_TRANSITIONS_SUCCESS = "FETCH_ORDER_TRANSITIONS_SUCCESS"
export const FETCH_ORDER_TRANSITIONS_FAIL = "FETCH_ORDER_TRANSITIONS_FAIL"

export const EXECUTE_ORDER_TRANSITION = "EXECUTE_ORDER_TRANSITION"
export const EXECUTE_ORDER_TRANSITION_SUCCESS = "EXECUTE_ORDER_TRANSITION_SUCCESS"
export const EXECUTE_ORDER_TRANSITION_FAIL = "EXECUTE_ORDER_TRANSITION_FAIL"

export const CLEAR_WORKFLOW_ERROR = "CLEAR_WORKFLOW_ERROR"
